import { atom } from 'recoil';

export const teacherSubjectState = atom({
  key: 'teacherSubjectState',
  default: null,
});
